import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';

import { Button } from '../atom/Button';
import { Flex } from '../atom/Layout';
import { Text } from '../atom/Text';
import { HorizonGreyLine } from '../atom/HorizonGreyLine';
import { Padding } from '../atom/Padding';
import { InputRadioList } from '../organism/InputRadioList';
import { ArrowToggle } from '../organism/Toggle';
import VoucherCoupon from '../organism/VoucherCoupon';

import ThemeStyle from '../../../lib/style/ThemeStyle';
import OrderPaybackRefundInfo from '../../../domain/order/Item/OrderPaybackRefundInfo';
import OrderOptionsInfo from '../../../domain/order/Item/OrderOptionsInfo';
import {
  AllowMarketingCheck,
  isShowOrderAllowMarketing,
} from '../organism/AllowMarketing';

export const OrderTemplate = ({
  process = { title: '', description: [] },
  onChange = undefined,
  onCheck = undefined,
  onSelectAccount = undefined,
  onPayMethod = undefined,
  onSelectVoucherCoupon = undefined,
  finalPrice = '',
  discountPrice = '',
  finalShippingFee = '',
  defaultPrice = '',
  pg = '',
  pay_method = '',
  payback = false,
  allowMarketing = false,
  allowMarketingInitialValue = false,
  handleAllowMarketing = (_) => {},
  couponOnly = false,
  children,
}) => {
  return (
    <Flex column alignItems="stretch" padding="0 0 3.125rem">
      <Layout title="1. 상품정보" required>
        <OrderOptionsInfo />
        {process.description.length > 0 && (
          <Padding top="10">
            <ArrowToggle
              hasBorderRadius
              content={[process]}
              titleBackground={ThemeStyle.background.grey}
            />
          </Padding>
        )}
      </Layout>
      {onSelectVoucherCoupon && (
        <Layout title="2. 상품권/쿠폰 사용">
          <VoucherCoupon
            status="usable"
            couponOnly={couponOnly}
            onSelectVoucherCoupon={onSelectVoucherCoupon}
          />
        </Layout>
      )}
      {children}
      <Padding bottom={20}>
        <HorizonGreyLine />
      </Padding>
      <Layout title="결제 상세">
        <BoxBottomGrey>
          <Flex column alignItems="stretch" width="100%">
            <Flex justifyContent="space-between">
              <Text size={14} weight="medium">
                총 상품 금액
              </Text>
              <Text size={14} weight="medium">
                {defaultPrice.toLocaleString()} 원
              </Text>
            </Flex>
            <Flex justifyContent="space-between" padding="0.313rem 0">
              <Text size={12} weight="medium">
                할인 금액
              </Text>
              <Text size={12} weight="medium" color="orangePink">
                {`- ${discountPrice.toLocaleString()}원`}
              </Text>
            </Flex>
            <Flex justifyContent="space-between">
              <Text size={12}>배송비</Text>
              <Text size={12}>{finalShippingFee.toLocaleString()} 원</Text>
            </Flex>
          </Flex>
          <Flex justifyContent="space-between" width="100%" padding="1rem">
            <Text size={12} weight="medium">
              최종 결제금액
            </Text>
            <Text size={12} weight="medium">
              {finalPrice.toLocaleString()} 원
            </Text>
          </Flex>
        </BoxBottomGrey>
      </Layout>
      <Text weight="medium">결제수단</Text>
      <Flex wrap={+true} justifyContent="flex-start" padding="0.625rem 0 0">
        <InputRadioList
          radioData={[
            {
              label: '카카오페이',
              value: 'kakaopay',
              checked: pg === 'kakaopay',
              onChange: (e) => onPayMethod(e),
            },
            {
              label: '신용/체크카드',
              value: 'card',
              checked: pay_method === 'card',
              onChange: (e) => onPayMethod(e),
            },
            {
              label: '가상계좌',
              value: 'vbank',
              checked: pay_method === 'vbank',
              onChange: (e) => onPayMethod(e),
            },
          ]}
        />
      </Flex>
      {pay_method === 'vbank' && payback && (
        <Padding top={32}>
          <OrderPaybackRefundInfo
            onSelectAccount={onSelectAccount}
            onChange={onChange}
            paybackText
          />
        </Padding>
      )}
      {isShowOrderAllowMarketing(allowMarketingInitialValue) && (
        <AllowMarketingCheck
          margin="2.5rem 0 0"
          allowMarketing={allowMarketing}
          onClick={() => handleAllowMarketing(!allowMarketing)}
        />
      )}
      <Button onClick={onCheck} style={{ marginTop: '2rem' }}>
        <Text size={18}>{`총 ${finalPrice.toLocaleString()}원 결제하기`}</Text>
      </Button>
    </Flex>
  );
};

export const BoxBottomGrey = ({ children }) => {
  return (
    <BoxContainer
      column
      style={{
        borderRadius: '6px',
        border: `solid 1px ${ThemeStyle.color.pinkishGrey}`,
      }}
    >
      <Flex column padding="1.25rem 1rem" width="100%">
        {children[0]}
      </Flex>
      <Flex
        style={{
          backgroundColor: ThemeStyle.background.grey,
          borderTop: `solid 1px ${ThemeStyle.color.pinkishGrey}`,
        }}
        column
        alignItems="strecth"
        width="100%"
      >
        {children[1]}
      </Flex>
    </BoxContainer>
  );
};

export const Layout = ({ title = '', required = false, children }) => (
  <Flex column alignItems="stretch" j>
    <Text weight="medium">
      {title} {required && <Text color="orangePink">*</Text>}
    </Text>
    <Flex column alignItems="stretch" padding="0.625rem 0 2.5rem">
      {children}
    </Flex>
  </Flex>
);

const BoxContainer = styled(Flex)`
  border-radius: 6px;
  border: solid 1px ${(props) => props.theme.color.pinkishGrey};
`;
